export default __webpack_public_path__ + "3a051ce73ee86f7b7a3aeb0bf441f9eb.png";